import { t } from "../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';
import AddIcon from '@mui/icons-material/Add';

import {getControlDocumentsList} from '../../Properties/Properties';
import {DocumentOnList, Documents} from '../documents';
import {getServicePromise} from '../HttpService/HttpService';
import styles from './ExternalControlStyle.module.scss';


export const ExternalControlFormDocuments = ({
                                               controlUuid,
                                               filesActive,
                                               projectUuid,
                                             }) => {
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const [fetchingOn, setFetchingOn] = useState(filesActive);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    if (!controlUuid || !fetchingOn) { return }
    const callPromise = getServicePromise(
      getControlDocumentsList(controlUuid), 'GET');
    callPromise.then(
      (documents_) => {
        setDocuments(documents_.filter(document => !!document.file));
        setFetchingOn(false);
      },
      (error) => {
        setFetchingOn(false);
      }
    );
  }, [controlUuid, fetchingOn]);

  return (
    <>
      <div className={`row ${styles.filesRow}`}>
        <button
          className='btn save-btn uppercase'
          disabled={!filesActive}
          type='button'
          onClick={() => filesActive ? setDocumentsOpen(true) : {}}
        >
          <AddIcon /><span className="sr-only">{t('g-add')}</span> {t('g-file')}
        </button>
        {!filesActive && <p className='info-text'>{t('external-controls-file-upload-enable-after-saving')}</p>}
      </div>
      {filesActive && (
        <>
          {documents.map(document =>
            <DocumentOnList
              canRemove
              controlUuid={controlUuid}
              document={document}
              key={document.id}
              onRemoveDocument={() => {
                setFetchingOn(true);
                setDocumentsOpen(false);
              }}
            />
          )}
          {documentsOpen &&
            <Documents
              controlUuid={controlUuid}
              excludeFromCurrentControl
              inPopup
              popUpTitle={t('external-controls-adding-file')}
              projectUuid={projectUuid}
              onAddSuccess={() => {
                setFetchingOn(true);
                setDocumentsOpen(false);
              }}
              onCancel={() => setDocumentsOpen(false)}
            />
          }
        </>
      )}
    </>
  )
};
